import React from "react";
import './CommonSearchInput.css';
import searchIcon from '../../../../../assets/search.svg';
import { useStore } from "../../../../../Hooks/useStore";
import { observer } from "mobx-react";

const CommonSearchInput = observer((props) => {
    const {rootStore} = useStore();
    return(
        <div className="main">
            <input style={{maxWidth: props.mWidth,width: props.mWidth ? "100%" : 320}} type="text" className="searchInput" placeholder={props.placeholder?props.placeholder:"Search"} onChange={props.onchange} onKeyDown={props.onkeydown && props.onkeydown} />
            <img src={searchIcon} className="searchIcon" />
        </div>
    )
});

export default CommonSearchInput;